import script from "./EMailList.vue?vue&type=script&setup=true&lang=ts"
export * from "./EMailList.vue?vue&type=script&setup=true&lang=ts"

import "./EMailList.vue?vue&type=style&index=0&id=0fa320a6&lang=scss"

const __exports__ = script;

export default __exports__